const ACTIVITY_TYPE_DEBT: string = 'debt';

export default ACTIVITY_TYPE_DEBT;
